export default __webpack_public_path__ + "locales/ja-JP/PeopleTranslations.json?hash=25460cb27b83f0ac0504af3d50a1bc98";